module.exports = __webpack_public_path__ + "img/feature-1.a3b9d97f.webp";